import styled from 'styled-components';
import {dFlexSpaceBetween, ellipsis, GRAY, mobileMedia} from '../../../../../globalVariables/GlobalVariables';

export const popUpTop = styled.div`
    height: 56px;
    ${dFlexSpaceBetween};
    border-bottom: 1px solid ;///to do get color form react-share
    .close{        
            opacity: 0.5;
            background-color:  ${GRAY};
            border-radius: 50%;
            min-width: 30px;
            width: 30px;
            height: 30px;
            margin: 12px;
            transform-origin: center;
        }
    }  
`;

export const popTitle = styled.div`
    font-weight: 600;
    margin-inline-start: 15px;
    
    ${ellipsis};
    ${mobileMedia}{
        font-size: 14px;
    }
`;

